module.exports = __webpack_public_path__ + "static/media/09.a740963c.mp3";